import http from "@/http-common";

/* eslint-disable */
class UserInfoDataService {
  getUserInfo(data: any): Promise<any> {
    const userId = { data: data };
    return http.api.post("/getUserInfo/", userId);
  }

  UpdateUserInfo(data: any): Promise<any> {
    return http.api.post("/updateUserInfo/", data);
  }

  getSideMenuList(data: any): Promise<any> {
    return http.api.post("/getSideMenuList/", data);
  }
  
  getSubMenuList(data: any): Promise<any> {
    return http.api.post("/getSubMenuList/", data);
  }

  insertUserInfo(data: any): Promise<any> {
    return http.api.post("/insertUserInfo/", data);
  }

  send_authenticationID(data: any): Promise<any> {
    return http.api.post("/send_authenticationID/", data);
  }

  getStationInfo(data : any): Promise<any>{
    return http.api.post("/getStationData/", data);
  }

  getEmployeeIDInfo(data : any): Promise<any>{
    return http.api.post("/getEmployeeIDData/", data);
  }
  
  getPermissionDetail(data = {}): Promise<any> {
    return http.api.post("/getPermissionDetail/", data);
  }

  getPermissionDetailforApproval(data : any): Promise<any> {
    return http.api.post("/getPermissionDetailforApproval/", data);
  }

  getUserPermissionDetail(data : any): Promise<any> {
    return http.api.post("/getUserPermissionDetail/",data);
  }

  insertUpdatedUserPermissionData(data: any,data1:any,data2 : any,data3 : any): Promise<any> {
    const param = {usrID: data, oldFlg : data1, newFlg:data2,stationCode:data3};
    return http.api.post("/insertUpdatedUserPermission/", param);
  }

  getPermissionDetailList(data : any): Promise<any>{
    return http.api.post("/getPermissionDetailList/", data);
  }

  updatedUserPermissionData(param: any): Promise<any> {
    return http.api.post("/updatedUserPermissionData/", param);
    
  }

  getUserPermission(data : any): Promise<any> {
    return http.api.post("/getUserPermissionInfo/", data);
  }

  getDistAdminList(): Promise<any>{
    return http.api.post("/getDistAdminList/");
  }

  getUserIDInfo(data : any): Promise<any>{
    return http.api.post("/getUserIDData/", data);
  }

  getEmployeeStationDuplicateInfo(data : any): Promise<any>{
    return http.api.post("/getEmployeeStationDuplicateData/", data);
  }
  
  insertAdminUserInfo(data: any): Promise<any> {
    return http.api.post("/insertAdminUserInfo/", data);
  }

  checkCompanyDetailInfo(data : any): Promise<any>{
    return http.api.post("/checkCompanyDetailInfo/", data);
  }

  getAdministrator(data : any): Promise<any>{
    return http.api.post("/getAdministrator/", data);
  }

  checkApprovalRequest(data : any): Promise<any>{
    return http.api.post("/checkApprovalRequest/", data);
  }

  insertAlternativeLogin(data : any): Promise<any>{
    return http.api.post("/insertAlternativeLogin/", data);
  }

  getMenuStationMapping(data : any): Promise<any>{
    return http.api.post("/getMenuStationMapping/", data);
  }

}

export default new UserInfoDataService();
